import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './overview-cta-skeleton.scss';

export const OverviewCtaSkeleton = memo(({ isMobile = false, withCollapse = false }) => {
  return (
    <Skeleton
      className={classnames('overview-cta-skeleton d-block rounded-6', {
        'w-100': isMobile,
        'top-view pos-a right-0': !isMobile && !withCollapse,
      })}
    />
  );
});

OverviewCtaSkeleton.displayName = 'OverviewCtaSkeleton';
OverviewCtaSkeleton.propTypes = {
  isMobile: PropTypes.bool,
  withCollapse: PropTypes.bool,
};
